import { Component, OnDestroy, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AppStore,
  defaultSettingsTab,
  setDefaultSettingsTab,
} from '../../../../state/app.repository';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppService } from '../../../../core/services/app.service';
import { TooltipDirective } from '../../../../shared/components/ui/tooltip/tooltip.directive';
import { SettingsGeneral } from '../../components/settings-general/settings-general';
import { SettingsAudio } from '../../components/settings-audio/settings-audio';
import { SettingsApp } from '../../components/settings-app/settings-app';
import { SettingsProfile } from '../../components/settings-profile/settings-profile';
import { faPenPaintbrush } from '@fortawesome/pro-duotone-svg-icons/faPenPaintbrush';
import { SettingsPermissions } from '../../components/settings-permissions/settings-permissions';
import { PermissionStore } from '../../../../state/permissions.repository';
import { TranslatePipe } from '@ngx-translate/core';
import {
  faCogs,
  faKey,
  faCameraMovie,
  faHeadset,
  faUser,
  faUsers,
  faCode,
  faBan,
  faDoorOpen,
} from '@fortawesome/pro-duotone-svg-icons';
import { UserLogin } from '../../../user-login';
import { Fieldset } from '../../../../shared/components/ui/fieldset/fieldset';
import { SettingsVideo } from '../../components/settings-video/settings-video';
import { SettingsDeveloper } from '../../components/settings-developer/settings-developer';
import { SettingsBans } from '../../components/settings-bans/settings-bans';
import { SettingsRooms } from '../../components/settings-rooms/settings-rooms';
import { AppConfigStore } from '../../../../state/app-config.repository';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'andor-general-settings',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslatePipe,
    SettingsApp,
    SettingsAudio,
    SettingsVideo,
    SettingsApp,
    TooltipDirective,
    SettingsPermissions,
    SettingsApp,
    SettingsGeneral,
    SettingsProfile,
    UserLogin,
    Fieldset,
    SettingsDeveloper,
    SettingsBans,
    SettingsRooms,
  ],
  templateUrl: './general-settings.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './general-settings.scss',
})
export class GeneralSettings implements OnDestroy {
  protected readonly faHeadset = faHeadset;
  protected readonly faCameraMovie = faCameraMovie;
  protected readonly faCogs = faCogs;
  protected readonly faUser = faUser;
  protected readonly faUsers = faUsers;
  protected readonly faPenPaintbrush = faPenPaintbrush;
  protected readonly faKey = faKey;
  protected readonly faCode = faCode;
  protected readonly faBan = faBan;
  protected readonly faDoorOpen = faDoorOpen;
  developerMode = signal<boolean>(false);
  activeSection = signal<
    | 'video'
    | 'audio'
    | 'misc'
    | 'profile'
    | 'app'
    | 'permissions'
    | 'login'
    | 'developer'
    | 'bans'
    | 'rooms'
  >(defaultSettingsTab);
  constructor(
    public appStore: AppStore,
    public appService: AppService,
    public permissionStore: PermissionStore,
    public appConfigStore: AppConfigStore
  ) {
    appConfigStore.developerMode$.pipe(takeUntilDestroyed()).subscribe((developerMode) => {
      this.developerMode.set(developerMode);
    });
  }

  ngOnDestroy(): void {
    setDefaultSettingsTab('audio');
  }
}
